/**
 * Typed binding for the /auth/* endpoints.
 *
 * Login and MFA are NOT here — Cloudflare Access owns those flows
 * (Option B in PR #4b). The client exposes only:
 *   - me()      → the authenticated principal + roles + permissions
 *   - logout()  → invalidate the CORTEX session; returns the CF Access
 *                 logout URL the SPA should redirect to.
 */

import {
  AuthLogoutResponseSchema,
  AuthMeResponseSchema,
  type AuthLogoutResponse,
  type AuthMeResponse,
} from '../schemas/auth.js';
import type { RequestOptions, Transport } from './transport.js';

export interface AuthClient {
  me(options?: RequestOptions): Promise<AuthMeResponse>;
  logout(options?: RequestOptions): Promise<AuthLogoutResponse>;
}

export const createAuthClient = (transport: Transport): AuthClient => ({
  me: (options) => transport.get('/auth/me', AuthMeResponseSchema, options),
  logout: (options) => transport.post('/auth/logout', AuthLogoutResponseSchema, {}, options),
});
